export default __webpack_public_path__ + "static/media/intellij-idea.25cb17da.svg";